import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { Block, BlockViewState } from './types';

type StateVars = {
  blockViewStateMap: Record<Block['id'], BlockViewState | undefined>;
};

type StateFns = {
  setBlockViewState: (blockId: Block['id'], blockView: BlockViewState) => void;
  clearBlockViewState: (blockId: Block['id']) => void;
};

type State = StateVars & StateFns;

function createInitialState(): StateVars {
  return {
    blockViewStateMap: {},
  };
}

export const useBlockViewStore = create<State>()(
  subscribeWithSelector((set, get) => ({
    ...createInitialState(),
    setBlockViewState: (blockId: Block['id'], blockView: BlockViewState) => {
      set((state) => {
        return {
          ...state,
          blockViewStateMap: {
            ...state.blockViewStateMap,
            [blockId]: blockView,
          },
        };
      });
    },
    clearBlockViewState: (blockId: Block['id']) => {
      set((state) => {
        // delete key
        const { [blockId]: _, ...rest } = state.blockViewStateMap;
        return {
          ...state,
          blockViewStateMap: rest,
        };
      });
    },
  }))
);

// @ts-ignore
window.blockViewStore = useBlockViewStore;
